import { useOutOfRegion } from '~/hooks/useCheckRegionBounds';

export default function OutOfRegion() {
  const outOfRegion = useOutOfRegion();

  if (!outOfRegion) {
    return <div />;
  } else {
    return (
      <div
        aria-live="assertive"
        className="pointer-events-none absolute inset-0 z-30 flex select-none items-end px-4 py-6 shadow-md"
        id="cg-toast"
      >
        <div className="flex w-full flex-col items-end space-y-4">
          <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="flex items-start px-4 py-3">
              <div className="w-0 flex-1">
                <h3>⚠️ Outside of your region</h3>
                <div className="my-2">
                  Your organization does not currently have access to this region. All project functionality is still
                  available in this region while we approve your request. Go ahead and create your project!
                </div>
                <div className="my-2">
                  Click{' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-50 underline hover:text-blue-60"
                    href="mailto:support@civilgrid.com?subject=Request Additional Regions"
                  >
                    here
                  </a>{' '}
                  to request access.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
